import { createReducer } from 'redux-create-reducer'

import {
  FETCH_IMAGES_REQUEST,
  FETCH_IMAGES_SUCCESS,
} from '../constants';

const initialState = {}

export default createReducer(initialState, {
  [FETCH_IMAGES_REQUEST](state) {
    return {
      ...state,
    }
  },
  [FETCH_IMAGES_SUCCESS](state, { payload }) {
    return {
      ...state,
      ...payload,
    }
  },
})
